export function clearFlights() { return { type: 'FLIGHTS/CLEAR' } }
export function fetchFlights(idSeason, idDivision) { return { type: 'FLIGHTS/FETCH', idDivision, idSeason } }
export function addFlightedTeam(flightedTeam) { return { type: 'FLIGHTED_TEAMS/ADD', flightedTeam } }
export function moveFlightedTeamToAnotherFlight({ source, to, of, flightedTeams }) {
    return { type: 'FLIGHTED_TEAMS/MOVE', source, to, of, flightedTeams }
}
export function moveFlightedTeamsInFlight(args) { return { type: 'FLIGHTED_TEAMS/SORT', args } }
export function removeFlightedTeam(flightedTeam) { return { type: 'FLIGHTED_TEAMS/REMOVE', flightedTeam } }
export function sortFlights(from, to, idDivision) { return { type: 'FLIGHTS/SORT', from, to, idDivision } }
export function forceResort(idFlight) { return { type: 'FLIGHT/SORT/FORCE', idFlight }}